module.exports = __webpack_public_path__ + "static/linkedin-c945af7fa227545af2aca347b6b81d05.png";